import {ISlsOrd, ISlsOrdClient, ISlsOrdResponse} from "./slsordClient";

const reply = {
    "homes": [
        {
            "id": "30690",
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",
            "modelRid": 2791,
            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30690-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30690-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30690-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30690-parking.png"
            },
            "blockNumber": "7",
            "lotNumber": "1",
            "isSold": false,
            "marketingName": "Venn",
            "bedrooms": "2",
            "baths": "2.5",
            "style": "2-Story",
            "sqf": "1133",
            "price": 0,
            "options": [
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enhanced_side",
                    "valueName": "Enhanced Side Elevation",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevb00311",
                    "valueName": "Body: Urban Iron / Accent: Silver Mist / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW2857 Peace Yellow",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_b",
                    "valueName": "Elevation B",
                    "style": ""
                }
            ]
        },
        {
            "id": "30691",
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "modelRid": 2792,
            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30691-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30691-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30691-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30691-parking.png"
            },
            "blockNumber": "7",
            "lotNumber": "2",
            "isSold": false,
            "marketingName": "Convex",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1185",
            "price": 0,
            "options": [
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00244",
                    "valueName": "Body: Southwest Sagebrook / Accent: Almond / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW2813 Downing Straw",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                }
            ]
        },
        {
            "id": "30692",
            "modelRid": 2793,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30692-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30692-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30692-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30692-parking.png"
            },
            "blockNumber": "7",
            "lotNumber": "3",
            "isSold": false,
            "marketingName": "Torus",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1167",
            "price": 0,
            "options": [
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_c",
                    "valueName": "Elevation C",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevc00281",
                    "valueName": "Body: Georgian Grey / Accent: Urban Iron / Window Trim/Corner Trim: Match Adj Accent/Body Color Horizontal Band - Georgian Grey / Columns/Vents/Soffits: Grey / Railing: Black / Awning: Black / Gutter/Fascia: Grey/Colonial Grey / Door: SW6328 Fireweed",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                }
            ]
        },
        {
            "id": "30693",
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "modelRid": 2791,
            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30693-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30693-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30693-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30693-parking.png"
            },
            "blockNumber": "7",
            "lotNumber": "4",
            "isSold": false,
            "marketingName": "Venn",
            "bedrooms": "2",
            "baths": "2.5",
            "style": "2-Story",
            "sqf": "1133",
            "price": 0,
            "options": [
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_b",
                    "valueName": "Elevation B",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevb00313",
                    "valueName": "Body: Antique Cinnabar / Accent: Mocha / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW7020 Black Fox",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                }
            ]
        },
        {
            "id": "30694",
            "modelRid": 2793,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30694-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30694-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30694-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30694-parking.png"
            },
            "blockNumber": "8",
            "lotNumber": "1",
            "isSold": false,
            "marketingName": "Torus",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1167",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_detached",
                    "valueName": "Single Detached Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_YES",
                    "valueName": "Mirrored Orientation",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enhanced_side",
                    "valueName": "Enhanced Side Elevation",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000002",
                    "valueName": "Body: Flint / Accent: Silver Mist / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW9170 Acier / Entry Door: SW9170 Acier",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_c",
                    "valueName": "Elevation C",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevc00279",
                    "valueName": "Body: Antique Cinnabar / Accent: Georgian Grey / Window Trim/Corner Trim/Columns/Vents/Soffits: Grey / Georgian Grey / Railing: Black / Awning: Black / Gutter/Fascia: Grey/Colonial Grey / Door: SW2857 Peace Yellow",
                    "style": ""
                }
            ]
        },
        {
            "id": "30698",
            "modelRid": 2791,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30698-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30698-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30698-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30698-parking.png"
            },
            "blockNumber": "8",
            "lotNumber": "2",
            "isSold": false,
            "marketingName": "Venn",
            "bedrooms": "2",
            "baths": "2.5",
            "style": "2-Story",
            "sqf": "1133",
            "price": 0,
            "options": [
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000002",
                    "valueName": "Body: Flint / Accent: Silver Mist / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW9170 Acier / Entry Door: SW9170 Acier",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_YES",
                    "valueName": "Mirrored Orientation",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00248",
                    "valueName": "Body: Deep Brunswick / Accent: Georgian Grey / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW6328 Fireweed",
                    "style": ""
                }
            ]
        },
        {
            "id": "30697",
            "modelRid": 2793,
            "reservedTo": 0,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30697-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30697-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30697-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30697-parking.png"
            },
            "blockNumber": "8",
            "lotNumber": "3",
            "isSold": false,
            "marketingName": "Torus",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1167",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_YES",
                    "valueName": "Mirrored Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_b",
                    "valueName": "Elevation B",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevb00314",
                    "valueName": "Body: Teak / Accent: Sandy Tan / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW2839 Roycroft Copper Red",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000001",
                    "valueName": "Body: Natural Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW6148 Wool Skein / Entry Door: SW6148 Wool Skein",
                    "style": ""
                }
            ]
        },
        {
            "id": "30696",
            "modelRid": 2791,
            "reservedTo": 0,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30696-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30696-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30696-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30696-parking.png"
            },
            "blockNumber": "8",
            "lotNumber": "4",
            "isSold": false,
            "marketingName": "Venn",
            "bedrooms": "2",
            "baths": "2.5",
            "style": "2-Story",
            "sqf": "1133",
            "price": 0,
            "options": [
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_YES",
                    "valueName": "Mirrored Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_c",
                    "valueName": "Elevation C",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevc00280",
                    "valueName": "Body: Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim: Match Adj Accent/Body Color Horizontal Band - Almond / Columns/Vents/Soffits: Almond / Railing: Almond / Awning: Musket Brown / Gutter/Fascia: Musket Brown / Door: SW6215 Rocky River",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000001",
                    "valueName": "Body: Natural Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW6148 Wool Skein / Entry Door: SW6148 Wool Skein",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                }
            ]
        },
        {
            "id": "30695",
            "modelRid": 2793,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30695-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30695-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30695-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30695-parking.png"
            },
            "blockNumber": "8",
            "lotNumber": "5",
            "isSold": false,
            "marketingName": "Torus",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1167",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_YES",
                    "valueName": "Mirrored Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00245",
                    "valueName": "Body: Dover White / Accent: Dover White / Window Trim/Corner Trim/Columns/Vents/Soffit: White / Gutters/Fascia: Black / Railing: White / Door: SW6258 Tricorn Black",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000002",
                    "valueName": "Body: Flint / Accent: Silver Mist / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW9170 Acier / Entry Door: SW9170 Acier",
                    "style": ""
                }
            ]
        },
        {
            "id": "30699",
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "modelRid": 2792,
            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30699-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30699-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30699-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30699-parking.png"
            },
            "blockNumber": "9",
            "lotNumber": "1",
            "isSold": false,
            "marketingName": "Convex",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1185",
            "price": 0,
            "options": [
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00248",
                    "valueName": "Body: Deep Brunswick / Accent: Georgian Grey / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW6328 Fireweed",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000001",
                    "valueName": "Body: Natural Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW6148 Wool Skein / Entry Door: SW6148 Wool Skein",
                    "style": ""
                },
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_detached",
                    "valueName": "Single Detached Garage",
                    "style": ""
                }
            ]
        },
        {
            "id": "30700",
            "modelRid": 2792,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30700-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30700-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30700-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30700-parking.png"
            },
            "blockNumber": "9",
            "lotNumber": "2",
            "isSold": false,
            "marketingName": "Convex",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1185",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_b",
                    "valueName": "Elevation B",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevb00312",
                    "valueName": "Body: Dover White / Accent: Dover White / Window Trim/Corner Trim/Columns/Vents/Soffits: White / Gutter/Fascia: Black / Railing: White / Door: SW6258 Tricorn Black",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000002",
                    "valueName": "Body: Flint / Accent: Silver Mist / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW9170 Acier / Entry Door: SW9170 Acier",
                    "style": ""
                }
            ]
        },
        {
            "id": "30701",
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "modelRid": 2790,
            "reservedTo": 0,
            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30701-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30701-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30701-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30701-parking.png"
            },
            "blockNumber": "9",
            "lotNumber": "3",
            "isSold": false,
            "marketingName": "Prism",
            "bedrooms": "2",
            "baths": "2",
            "style": "2-Story",
            "sqf": "929",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00244",
                    "valueName": "Body: Southwest Sagebrook / Accent: Almond / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Almond / Railing: Almond / Door: SW2813 Downing Straw",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000002",
                    "valueName": "Body: Flint / Accent: Silver Mist / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW9170 Acier / Entry Door: SW9170 Acier",
                    "style": ""
                }
            ]
        },
        {
            "id": "30702",
            "modelRid": 2792,
            "reservedTo": 0,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30702-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30702-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30702-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30702-parking.png"
            },
            "blockNumber": "9",
            "lotNumber": "4",
            "isSold": false,
            "marketingName": "Convex",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1185",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enh_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_elevc00281",
                    "valueName": "Body: Georgian Grey / Accent: Urban Iron / Window Trim/Corner Trim: Match Adj Accent/Body Color Horizontal Band - Georgian Grey / Columns/Vents/Soffits: Grey / Railing: Black / Awning: Black / Gutter/Fascia: Grey/Colonial Grey / Door: SW6328 Fireweed",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Cool"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000001",
                    "valueName": "Body: Natural Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW6148 Wool Skein / Entry Door: SW6148 Wool Skein",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_c",
                    "valueName": "Elevation C",
                    "style": ""
                }
            ]
        },
        {
            "id": "30703",
            "modelRid": 2792,
            "reservedTo": 0,
            "modelId": "9981CO",
            "lotStreetAddress": "1234 Street Address",

            "waitlist": [],
            "images": {
                "elevation": "/kova_images/SlsOrd-30703-elevation.png",
                "firstFloor": "/kova_images/SlsOrd-30703-firstfloor.png",
                "secondFloor": "/kova_images/SlsOrd-30703-secondfloor.png",
                "parking": "/kova_images/SlsOrd-30703-parking.png"
            },
            "blockNumber": "9",
            "lotNumber": "5",
            "isSold": false,
            "marketingName": "Convex",
            "bedrooms": "3",
            "baths": "2",
            "style": "2-Story",
            "sqf": "1185",
            "price": 0,
            "options": [
                {
                    "selectionID": "GARAGE",
                    "selectionName": "Garage",
                    "valueID": "gar_paired1car",
                    "valueName": "Paired 1 Car Garage",
                    "style": ""
                },
                {
                    "selectionID": "ogvo000",
                    "selectionName": "On2 Homes at Green Valley Ranch",
                    "valueID": "ogvo000",
                    "valueName": "Selected",
                    "style": ""
                },
                {
                    "selectionID": "REVERSEPLAN",
                    "selectionName": "Garage Handing Selection",
                    "valueID": "REVERSE_NO",
                    "valueName": "Standard Orientation",
                    "style": ""
                },
                {
                    "selectionID": "ELEVATION",
                    "selectionName": "Elevation",
                    "valueID": "elev_a",
                    "valueName": "Elevation A",
                    "style": ""
                },
                {
                    "selectionID": "FOUNDATION",
                    "selectionName": "Foundation",
                    "valueID": "fnd_crawl",
                    "valueName": "Crawl Space Foundation",
                    "style": ""
                },
                {
                    "selectionID": "ENH_SIDE",
                    "selectionName": "Side Enhancement",
                    "valueID": "enhanced_side",
                    "valueName": "Enhanced Side Elevation",
                    "style": ""
                },
                {
                    "selectionID": "BEARPRESSURE",
                    "selectionName": "Bearing Pressures",
                    "valueID": "sys_none",
                    "valueName": "Not Selected",
                    "style": ""
                },
                {
                    "selectionID": "ELC_CHARGER",
                    "selectionName": "Electric Car Charger",
                    "valueID": "elc_charger1",
                    "valueName": "Electric Car Charger",
                    "style": ""
                },
                {
                    "selectionID": "EXT_COLORS",
                    "selectionName": "Exterior Color Schemes",
                    "valueID": "color_eleva00249",
                    "valueName": "Body: Antique Cinnabar / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Columns/Vents/Soffits: Almond / Gutter/Fascia: Musket Brown / Railing: Almond / Door: SW7020 Black Fox",
                    "style": ""
                },
                {
                    "selectionID": "WH_DESIGNPKG",
                    "selectionName": "Whole House Design Upgrade Package",
                    "valueID": "designpkg_group00O2",
                    "valueName": "Design Package Group 00",
                    "style": "Warm"
                },
                {
                    "selectionID": "EXT_GARCOLORS",
                    "selectionName": "Garage Exterior Color Schemes",
                    "valueID": "color_gar000001",
                    "valueName": "Body: Natural Almond / Accent: Stone Mountain Clay / Window Trim/Corner Trim/Vents/Soffits: Almond / Fascia/Gutter: Almond / Garage Door: SW6148 Wool Skein / Entry Door: SW6148 Wool Skein",
                    "style": ""
                }
            ]
        }
    ],
    "events": [],
    "lastEvent": -1,
    "cameras": []
};
class MockSlsOrdClient implements ISlsOrdClient {
    getSlsOrds(): Promise<ISlsOrd[]> {
        return new Promise<ISlsOrd[]>(resolve => {
            setTimeout(() => resolve(reply.homes as any), 1000);
        });
    }
    getSlsOrdMockData() {
        return reply;
    }
    getCommunityInfo(customerId?: number): Promise<ISlsOrdResponse> {
        return new Promise<ISlsOrdResponse>(resolve => {
            setTimeout(() => resolve(reply as any), 1000);
        });
    }
}


export default MockSlsOrdClient;